import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { SerialNumbers_ModuleContextService } from './SerialNumbers.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class SerialNumbers_audit_entities_dd_ComponentContextService {
  private readonly moduleContext: SerialNumbers_ModuleContextService;

  constructor(moduleContext: SerialNumbers_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'audit_entities_dd',
      type: ComponentType.selector
    }
  }
}